import PageLayout from "@/components/feature/PageLayout";
import { Link } from "react-router-dom";

export default function UnawareChargesPage() {
  return (
    <PageLayout>
      <div className="bg-white rounded-2xl border border-gray-200 p-8">
        <div className="mb-1">
          <span className="text-xs font-bold uppercase tracking-widest text-gray-400">Billing &amp; Payments</span>
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-4">I was unaware of the charges</h2>
        <div className="space-y-4 text-sm">
          <p className="text-gray-500">
            We understand this can be frustrating. Sometimes charges can go unnoticed, especially with subscription services. Let&apos;s figure out what happened.
          </p>
          <h4 className="font-semibold text-gray-800">Common reasons for unexpected charges:</h4>
          <ul className="list-disc list-inside space-y-2 text-gray-500">
            <li>A free trial period ended and converted to a paid subscription</li>
            <li>An annual subscription renewed automatically</li>
            <li>A family member or someone with access to your account made a purchase</li>
            <li>You may have signed up through a third-party offer or promotion</li>
          </ul>
          <h4 className="font-semibold text-gray-800">What you can do:</h4>
          <ol className="list-decimal list-inside space-y-2 text-gray-500">
            <li>Search your email for any sign-up confirmations from kingcraftech.com</li>
            <li>Contact us with the charge date and amount — we&apos;ll trace the origin</li>
            <li>If you did not authorize the charge, we will process a refund</li>
            <li>We can also cancel any active subscription to prevent future charges</li>
          </ol>
          <div className="bg-gray-50 border border-gray-200 rounded-xl p-4">
            <p className="text-sm text-gray-500">
              <strong className="text-gray-700">Our commitment:</strong> We take billing transparency seriously. If you were charged without clear notice, we will make it right.
            </p>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-gray-100 flex flex-col sm:flex-row gap-3">
          <Link to="/contact-support" className="inline-block bg-[#2d2f36] text-white px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer text-center">
            Contact Support
          </Link>
          <Link to="/dispute-resolution" className="inline-block border border-gray-200 text-gray-700 px-5 py-2.5 rounded-xl text-sm font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer text-center">
            Submit a Dispute Form
          </Link>
        </div>
      </div>
    </PageLayout>
  );
}
